import React from 'react';

import Cookies from '../cookies/Cookies';

const CookiesPage: React.FC = () => {
  return <Cookies />;
};

export default CookiesPage;
